import { DEFAULT_VIEW_ID } from '../defaults';
import { validateSelectedListId, validateStringInput } from '../utils/formValidationHelpers';
import { ContactListFilterItem } from './ContactListFilterItem';

/*
 * "none" value added to front-end enum to avoid unset errors; to filter out errors
 *
 * Matching server Enum found at "EE.Api/Entities/ContactListType.cs"
 */
export enum ListType {
    undefined = -1,
    static = 0,
    dynamic = 1,
    tag = 2,
    status = 3,
    pipeline = 4,
}

export interface ListItem {
    listId: number;
    type: ListType;
    name: string;
    viewId: number;
    isFavorite: boolean;
    isArchived: boolean;
}

/*
 * Property "isAuto" used for lists which are not explicitly created by the user
 * Property "items" is used to pass contactId's in a contact group list
 */
export interface CreateListRequest {
    listId?: number;
    name: string;
    type: ListType;
    filters: ContactListFilterItem[];
    viewId: number;
    isAuto: boolean;
    items: number[];
    isFavorite?: boolean;
    isArchived?: boolean;
}
export interface UpdateListRequest {
    listId: number;
    name: string;
    filters: ContactListFilterItem[];
    viewId: number;
    items?: number[];
    isFavorite?: boolean;
    isArchived?: boolean;
}

export type ContactsListAssignmentRequest = {
    listId: number;
    contactIds: number[];
};

/**
 * buildCreateList
 *
 * @description
 * Builds an object that matches that expected by the server for a request to
 * create a new contact list
 *
 * @hidden
 * IMPORTANT: filters should be validated using buildContactListFilterItem before
 * being passed to this method
 */
export function buildCreateList(args: {
    name: string;
    type: ListType;
    filters?: ContactListFilterItem[];
    viewId?: number;
    isAuto?: boolean;
    items?: number[];
    isFavorite?: boolean;
    isArchived?: boolean;
}): CreateListRequest {
    return {
        name: validateStringInput('name', args.name),
        type: args.type,
        filters: args.filters || [],
        viewId: args.viewId || DEFAULT_VIEW_ID,
        isAuto: args.isAuto === undefined ? false : args.isAuto,
        items: args.items || [],
        isFavorite: args.isFavorite === undefined ? false : args.isFavorite,
        isArchived: args.isArchived === undefined ? false : args.isArchived,
    };
}

/**
 * buildAssignContactsToList
 *
 * @description
 * Builds an object containing the values which, individually, are expected by
 * the server for a request to assign/ unassign contacts from a contact list
 */
export function buildContactsListAssignment(args: {
    listId: number;
    contactIds: number[];
}): ContactsListAssignmentRequest {
    return {
        listId: validateSelectedListId('listId', args.listId),
        contactIds: args.contactIds,
    };
}
